import React, { Component } from 'react';
import { connect } from 'react-redux';
import { combineStates, currentPageState, productsDispatcher, productState, viewsState,siteSettingsState } from '../../store';
import { GenericViewer, ProductCode, ProductDescription, ProductImage, ProductPrice } from '../../components';
import { getAccessoriesExtended,assignmentDecision, getAssignedValue,deflateModelVariables } from '../../util';
import { PropTypes } from 'prop-types';
import { Box } from '@mui/material';
import { translate, getLanguages } from '../../services';
export class CartItemDetailComponent extends Component {
  componentDidMount() {
    const { products, additionalProducts, configuration, importAccessories, amount } = this.props;
    additionalProducts && additionalProducts.forEach( product => !products[product.name]&& this.props.getProduct(product.name));
    getAccessoriesExtended( configuration, importAccessories, false, false, amount ).forEach( accessory => !products[accessory.assignedValue.name] && this.props.getProduct( accessory.assignedValue.name ) );
  }

  getItems(){
    const { additionalProducts, products, configuration, amount, importAccessories, materialCorrection, siteSettings,looseadditionalProduct } = this.props;
    const { modelConfigurators } = siteSettings.properties
    
    if( !configuration && additionalProducts && additionalProducts.length > 0 ){
      return additionalProducts;
    }

    //This is to handle the length of missing bomComponents/ accessories in the cart accessoryView
    let cssAmount = this.props.amount;
    let items = getAccessoriesExtended( configuration, importAccessories, false, false, amount ).map((accessory) => ({...products[accessory.assignedValue.name] || {...accessory.assignedValue, code: accessory.assignedValue.name}, 
      amount : accessory?.quantity ?? accessory.assignedValue.quantity, 
      materialCorrection: materialCorrection,
      LooseAcc:accessory.assignedValue.looseacc}));
    const missingBomComponentsInView = configuration && configuration.assignments && configuration.assignments.filter(assign => assign.key === null);
    let acc_items=[];
  
    if(looseadditionalProduct){
      const lang = getLanguages().first();
    const accessories = looseadditionalProduct[0]?.configuration && deflateModelVariables( looseadditionalProduct[0]?.configuration.model );
    const filteredAccessories = accessories && accessories.filter( accessory => 
      assignmentDecision( looseadditionalProduct[0]?.configuration.productModelType, lang )( accessory ) && 
      getAssignedValue( accessory ) !== looseadditionalProduct[0]?.configuration.product.name )
      .map((accessory) => ({...products[accessory.assignedValue.name] || {...accessory.assignedValue, code: accessory.assignedValue.name}, 
        amount : accessory?.quantity ?? accessory.assignedValue.quantity, 
        LooseAcc:true,
        materialCorrection: materialCorrection})
  );
    if(filteredAccessories){
      filteredAccessories.forEach(acc=>!items.any(i=>i.name==acc.name) && items.push(acc))
      
    }
   
    }
    if(missingBomComponentsInView && missingBomComponentsInView.any()){
      for(const [key, missingBomComponent] of Object.entries(missingBomComponentsInView) ){
        if ( !acc_items.any(item=>item.code === missingBomComponent.value ) ) {
          acc_items.push(products[missingBomComponent.value]);
        }
      }
    }
    this.props.bom? items.forEach((i)=>{
      let itemFound=0;
      this.props.bom.forEach((b)=>{if(i.name==b.name){
        itemFound+=1;
        acc_items.push({...i,configuredAcc:b.configuredAcc})
    }
  })
  if(itemFound==0){
    acc_items.push(i)
  }

  }):acc_items=items;
    return [... new Set(acc_items)].reduce( ( current, product ) => {
      if( !product || product.obsolete ) {
        return current;
      } 

      const code = product.name;
      if( current[code] ) {
        current[code].amount = product.amount ? current[code].amount + Number(product.amount) : current[code].amount + amount;
      } else {
          if(siteSettings.properties?.modelConfigurators && siteSettings.properties?.modelConfigurators?.includes(this.props.configuration.materialKey)|| configuration.materialKey=="TruckMaster"){
            if(configuration.materialKey=="TruckMaster"){
                         let pr={}
                         configuration.product.childProduct && configuration.product.childProduct.forEach(c=>{pr[c.code]=({amount:(c.amount)})})
                         current[code] = Object.assign( {}, product, { amount: modelConfigurators?pr[code]?.amount*amount||product.amount*amount || amount || 1 :   pr[code]?.amount * amount||product.amount * amount||amount||1 } );
                       }else{ 
                         current[code] = Object.assign( {}, product, { amount: modelConfigurators?.includes(configuration.materialKey) ? product.amount * cssAmount || amount || 1 : amount } );  
                       }
                   } 
                   else{
                     current[code] = Object.assign( {}, product, { amount: modelConfigurators?.includes(configuration.materialKey) ? Number(product.amount) || amount || 1 : amount } );
                     if ( configuration?.bomComponents?.length > 0 ) {
                       configuration?.bomComponents?.forEach( v => {
                         if ( v.fixedQuantity && v.component == code && (Number(v.itemNumber)< 9000)) {
                           current[code] = Object.assign( {}, product, { amount: v.quantity || amount || 1 } );
                         }
                         else if (v.fixedQuantity && v.component == code && (Number(v.itemNumber)>=9000)){
                           current[code] = Object.assign( {}, product, { amount: '' } );
                         }
                       } )
                     }
                   }
      }
      return current;
    }, {} );
  }

  render() {
    const { parentLayoutType, products, configuration, additionalProducts, isExpandable } = this.props;
    let viewToUse = !configuration && additionalProducts && additionalProducts.length ? 'cart' : 'cartaccessory';
    const detailTemplate = !configuration && additionalProducts && additionalProducts.length ? CartItemDetail : null;
    const className = !configuration && additionalProducts && additionalProducts.length ? "fp+mp" : null
    const items = this.getItems();

    const accessories = Object.values( items );

    let layout = this.props.views["cart"]

    return !accessories || !accessories.length ? null :<>
      <Box width="100%" height="100%" sx={{display:{md:"flex", xs:"none", background: "var(--primary-color-background-secondary-white, #FAFAFA)", borderBottom:"1px solid var(--primary-color-grey-10, #EBEBEB)"}}}>
        <div className='accessory-list'>
          <GenericViewer 
          view= { viewToUse }
          parentLayoutType={ layout }
          items={ accessories }
          detailTemplate={ detailTemplate }
          isExpandable = {isExpandable }
          className = {className}
      />
      </div>
      </Box>
      <Box key={this.props.key} overflow="hidden" width="100%" height="max-content" sx={{display:{md:"none", xs:"flex"}}}>
      {/* <div key={this.props.key} className='accessories' style={{background:"white"}}>
                  {accessories.map((item, key)=>{return(
                  <div key={key}className='accessory-container'>
                    <div className='accessory-image'>
                    <ProductImage product={ item } alt={ item.productCode } className="image-container" />
                    </div>
                    <div className='accessory-section'>
                      <div className='accessory-details'>
                      <ProductCode { ...item } />
                      <ProductDescription product={ item } ></ProductDescription>
                      <span className='quantity'>{`${translate("Quantity")}: ${item.amount}`}</span>
                      </div>
                        <div className='accessory-price'>
                        <ProductPrice product={item}></ProductPrice>
                      </div>
                    </div>
                  </div>)})}
                </div> */}
                <GenericViewer 
          view= { viewToUse }
          parentLayoutType={ parentLayoutType }
          items={ accessories }
          detailTemplate={ detailTemplate }
          isExpandable = {isExpandable }
          className = {"mobile-grid-view"}
      />
      </Box>
    </>
  }
}

CartItemDetailComponent.propTypes = {
  configuration: PropTypes.shape( {
    model: PropTypes.shape( {} ),
    product: PropTypes.shape( {
      name: PropTypes.string
    } ),
    productModelType: PropTypes.number
  } ),
  getProduct: PropTypes.func.isRequired,
  parentLayoutType: PropTypes.string,
  product: PropTypes.shape( {} )
};

export const CartItemDetail = connect( combineStates( productState,siteSettingsState, currentPageState, viewsState), productsDispatcher  )( CartItemDetailComponent );
